import { CenterBackground } from "../common/components";
import { TextL } from "../common/text";
import { ImWarning } from "react-icons/im";

const NotFound = () => {
  return (
    <CenterBackground style={{ gap: "10px" }}>
      <ImWarning size={30} />
      <TextL>존재하지 않는 페이지입니다.</TextL>
    </CenterBackground>
  );
};

export default NotFound;
